import React from "react";
import { inject, observer } from "mobx-react";
import SortClipsDropdown from "../components/SortClipsDropdown";
import TablePagination from "@material-ui/core/TablePagination";
import Toolbar from "@material-ui/core/Toolbar";
import { withStyles } from "@material-ui/core/styles";

export const styles = theme => ({
  root: {
    fontSize: theme.typography.pxToRem(12)
  },
  toolbar: {
    height: 56,
    minHeight: 56,
    paddingRight: 30,
    paddingTop: 8,
    justifyContent: "flex-end"
  }
});

class MyClipsPaginationBar extends React.Component {
  render() {
    const { myClipsStore, classes } = this.props;
    return myClipsStore.videos && myClipsStore.videos.length === 0 ? null : (
      <Toolbar className={classes.toolbar}>
        <SortClipsDropdown
          sortBy={myClipsStore.sortBy}
          sortByOptions={myClipsStore.sortByOptions}
          onChange={e => {
            myClipsStore.setSortBy(e.target.value);
          }}
        />
        <TablePagination
          component="div"
          count={myClipsStore.totalVideos}
          rowsPerPage={myClipsStore.videosPerPage}
          page={myClipsStore.page}
          onPageChange={(event, page) => {
            myClipsStore.setPage(page);
          }}
          onRowsPerPageChange={event => {
            myClipsStore.setClipsPerPage(event.target.value);
          }}
          labelRowsPerPage="Videos per page"
          rowsPerPageOptions={[12, 18, 25]}
        />
      </Toolbar>
    );
  }
}

export default inject("myClipsStore")(
  withStyles(styles)(observer(MyClipsPaginationBar))
);



// WEBPACK FOOTER //
// ./src/containers/MyClipsPaginationBar.js